import { Link } from "react-router-dom";
import { socialLinks } from "@/pages/Contact";

export const Footer = () => (
  <footer className="bg-pine-ink text-cream relative grain overflow-hidden" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-16 lg:py-24">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <p className="font-serif italic text-3xl lg:text-4xl leading-snug text-cream">
            "And whoever emigrates for the cause of Allah will find on earth many locations and abundance."
          </p>
          <p className="mt-4 font-mono text-xs tracking-[0.3em] uppercase text-petal-soft">Qur'an 4:100</p>
        </div>
        <div className="md:col-span-3">
          <p className="font-mono text-xs tracking-[0.3em] uppercase text-sage-light mb-6">Explore</p>
          <ul className="space-y-3 text-sm">
            <li><Link data-testid="footer-map-link" className="hover:text-petal-soft transition-colors" to="/map">World Map</Link></li>
            <li><Link data-testid="footer-countries-link" className="hover:text-petal-soft transition-colors" to="/countries">Country Profiles</Link></li>
            <li><Link data-testid="footer-steps-link" className="hover:text-petal-soft transition-colors" to="/steps">The Roadmap</Link></li>
            <li><Link data-testid="footer-quiz-link" className="hover:text-petal-soft transition-colors" to="/quiz">Find Your Country</Link></li>
            <li><Link data-testid="footer-about-link" className="hover:text-petal-soft transition-colors" to="/about">Meet Hijrah Mom</Link></li>
            <li><Link data-testid="footer-contact-link" className="hover:text-petal-soft transition-colors" to="/contact">Connect &amp; Network</Link></li>
          </ul>
        </div>
        <div className="md:col-span-4">
          <p className="font-mono text-xs tracking-[0.3em] uppercase text-sage-light mb-6">A note from Mom</p>
          <p className="text-sm leading-relaxed text-sage-light">
            Everything on this site is one American Muslim mother's research and honest opinion — not legal, immigration, or financial advice. Verify visas with embassies, custody with attorneys, and big decisions with istikhara and people of knowledge.
          </p>
        </div>
      </div>
      <div className="mt-16 pt-8 border-t border-cream/10 flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex flex-wrap items-center gap-5">
          <img src="/logo-wide.png" alt="Hijrah Mom" data-testid="footer-logo-image" className="h-20 w-auto rounded-xl" />
          <div className="flex items-center gap-2" data-testid="footer-social-links">
            {socialLinks.map((l) => (
              <a key={l.name} href={l.url} target="_blank" rel="noopener noreferrer" aria-label={l.name} data-testid={`footer-${l.testid}`} className="w-10 h-10 rounded-full bg-cream/10 border border-cream/15 flex items-center justify-center text-cream hover:bg-petal hover:border-petal transition-colors">
                <l.icon size={17} />
              </a>
            ))}
          </div>
        </div>
        <p className="font-mono text-xs text-sage-light tracking-widest">MADE WITH DU'A · © 2026</p>
      </div>
    </div>
  </footer>
);
